import { Chip, IconButton, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@common/Icon/Icon";
import { EORDER_STATUS, EORDER_TYPE } from "@constants";
import { IOrder, IOrderOffer } from "./interface/IOrder";
import { useStyle } from "./style";
import { OrderOffer } from "./offer/OrderOffer";
import { TCancelOrder } from "./type/TCancelOrder";

interface IParams {
    cancelOrder?: TCancelOrder;
    offerList: IOrderOffer[];
    order: IOrder;
}

export const OrderItemList = (props: IParams) => {
    const [isOpen, setIsOpen] = useState(false);
    const { cancelOrder, offerList, order } = props;
    const orderStatus = EORDER_STATUS[order.status];
    const { t } = useTranslation(["order", "common", "glossary"]);
    const { classes } = useStyle({ orderStatus });

    const arrowPosition = isOpen ? "up" : "down";

    const orderTitle =
        EORDER_TYPE[order.orderType] === EORDER_TYPE.REPLACEMENT
            ? EORDER_TYPE[order.orderType]
            : `${EORDER_TYPE[order.orderType]} x${offerList.length}`;

    return (
        <Stack paddingInline={2} spacing={2}>
            <Stack direction="row" justifyContent="space-between">
                <Stack justifyContent="space-between">
                    <Typography color="secondary" variant="h3">
                        {orderTitle}
                    </Typography>
                    <Stack>
                        <Typography color="secondary" variant="normal">
                            {t("order:orderedOn")} {order.createdDateTime}
                        </Typography>
                        <Typography color="secondary" variant="normal">
                            {t("order:orderId", { id: order.reference })}
                        </Typography>
                    </Stack>
                </Stack>
                <Stack alignItems="center" spacing={1}>
                    <Stack alignItems="center" justifyContent="center" spacing={-0.4}>
                        <Typography color="primary" variant="h4">
                            {t("common:price", {
                                price: order.totalRecurringChargeAmount,
                            })}
                        </Typography>
                        <Typography color="secondary" variant="small">
                            {t("glossary:aMonth")}
                        </Typography>
                    </Stack>
                    {EORDER_TYPE[order.orderType] !== EORDER_TYPE.REPLACEMENT && (
                        <IconButton
                            aria-label={isOpen ? t("glossary:close") : t("glossary:open")}
                            color="secondary"
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            <Icon name={`arrow-${arrowPosition}`} />
                        </IconButton>
                    )}
                </Stack>
            </Stack>
            <Chip className={classes.chip} label={orderStatus} />
            {isOpen && (
                <Stack>
                    <Typography align="right" color="secondary" variant="small">
                        {t("order:onceOffCharge")}
                    </Typography>
                    <Stack spacing={3}>
                        {offerList.map((offer: IOrderOffer) => (
                            <OrderOffer
                                cancelOrder={cancelOrder}
                                key={offer.name}
                                offer={offer}
                                orderReference={order.reference}
                            />
                        ))}
                    </Stack>
                </Stack>
            )}
        </Stack>
    );
};
